import { render, staticRenderFns } from "./ProgramControl.vue?vue&type=template&id=d53c7ff6&scoped=true"
import script from "./ProgramControl.vue?vue&type=script&lang=js"
export * from "./ProgramControl.vue?vue&type=script&lang=js"
import style0 from "./ProgramControl.vue?vue&type=style&index=0&id=d53c7ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53c7ff6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
